import { useEffect, useMemo, useState } from "react";
import { compose } from "redux";

import { DatePicker } from "@material-ui/pickers/DatePicker";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import ApiButton from "../../../shared/ui/Api.Button";
import TransactionsTableButtons from "./TransactionsTableButtons";

import { investorDepotTransactionCategory } from "../../../shared/dictionary/enums";
import TableNew, { CELL_TYPES } from "../../../shared/Table";
import { allDepotsConst } from "../Transactions.Helper";

import { transactionConnector } from "../../../services/transactions/connector";
import { usersConnector } from "../../../services/users/connectors/usersConnector";
import PropTypes from "prop-types";

const TransactionsComponent = (props) => {
  const columns = useMemo(() => {
    return [
      { key: "Time", label: "Time", visible: true, type: CELL_TYPES.date },
      {
        key: "JournalType",
        label: "JournalType",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "Category",
        label: "Category",
        visible: true,
        enumDict: investorDepotTransactionCategory,
        type: CELL_TYPES.enum,
      },
      {
        key: "PostingType",
        label: "PostingType",
        visible: true,
        type: CELL_TYPES.text,
      },
      { key: "Amount", label: "Amount", visible: true, type: CELL_TYPES.money },
      {
        key: "Currency",
        label: "Currency",
        visible: true,
        type: CELL_TYPES.text,
      },
    ];
  }, []);

  const [depotId, setDepotId] = useState(props.depotId);

  useEffect(() => {
    getTransactionData();

    return () => {
      const date = new Date();
      props.changeTransactionListFilterDate(
        "from",
        new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12),
      );
      props.changeTransactionListFilterDate(
        "to",
        new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12),
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.currentUser?.Ssn]);

  const handleChangeFrom = (date) => {
    date = new Date(date);
    props.changeTransactionListFilterDate(
      "from",
      new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12),
    );
  };

  const handleChangeTo = (date) => {
    date = new Date(date);
    props.changeTransactionListFilterDate(
      "to",
      new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12),
    );
  };

  const handleChangeDepotId = (e) => {
    const id = e.target.value;
    const table = props.transactions.table;

    setDepotId(id);
    props.getTransactionsForDepot(
      id,
      table.timespan.from,
      table.timespan.to,
      props.currentUser.Id,
    );
  };

  const handleFilter = () => {
    getTransactionData();
  };

  const getTransactionData = () => {
    const table = props.transactions.table;

    if (depotId) {
      props.getTransactionsForDepot(
        depotId,
        table.timespan.from,
        table.timespan.to,
        props.currentUser.Id,
      );
    } else {
      props.getTransactions(table.timespan.from, table.timespan.to);
    }
  };

  return (
    <div className="transactions-layout body-height content-padding">
      <div className="row">
        <div className="col-md-6">
          From date
          <br />
          <DatePicker
            inputVariant="outlined"
            className="small-datepicker"
            value={props.transactions.table.timespan.from}
            onChange={handleChangeFrom}
            helperText="From date"
          />
        </div>
        <div className="col-md-6">
          To date
          <br />
          <DatePicker
            inputVariant="outlined"
            className="small-datepicker"
            value={props.transactions.table.timespan.to}
            onChange={handleChangeTo}
            helperText="To date"
          />
        </div>
        <div className="col-md-12">
          <ApiButton
            buttonLabel={"Filter"}
            sending={props.transactions.fetching}
            sent={props.transactions.fetched}
            error={props.transactions.error}
            onButtonClick={handleFilter}
          />
          <br />
        </div>
        {props.deposts && (
          <div className="col-md-12">
            <br />
            <TextField
              size="small"
              fullWidth
              variant="outlined"
              select
              label={"Depot Id"}
              value={depotId}
              onChange={handleChangeDepotId}
            >
              <MenuItem value={allDepotsConst} key={allDepotsConst}>
                {allDepotsConst}
              </MenuItem>
              {props.deposts.map((id) => {
                return (
                  <MenuItem value={id} key={id}>
                    {id}
                  </MenuItem>
                );
              })}
            </TextField>
          </div>
        )}
      </div>
      {!props.transactions.fetched ? (
        <div />
      ) : (
        <TableNew
          {...props}
          columns={columns}
          items={props.transactions.data}
          tableKey={"transactions-main"}
          selectId={"Id"}
          aboveContentRenderer={(getSelected, rows) => {
            return (
              <TransactionsTableButtons getSelected={getSelected} rows={rows} />
            );
          }}
        />
      )}
    </div>
  );
};

TransactionsComponent.propTypes = {
  transactions: PropTypes.object,
  deposts: PropTypes.array,
  currentUser: PropTypes.object,
  depotId: PropTypes.string,
  getTransactions: PropTypes.func,
  getTransactionsForDepot: PropTypes.func,
  changeTransactionListFilterDate: PropTypes.func,
};

export default compose(transactionConnector)(TransactionsComponent);
export const TransactionUserComponent = compose(
  transactionConnector,
  usersConnector,
)(TransactionsComponent);
